import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { InFilter, TermFilter } from '@dofleini/query-builder';
import { clientFilter, establishmentFilter } from 'modules/audit/management/constants';
import { TEMPLATES_LIST_KEY } from 'modules/settings/templates/main/constants';
import { ServiceType } from 'modules/settings/templates/main/interfaces';
import { TemplateService } from 'modules/settings/templates/main/services';

export const withObjetIdFilter = (filter: Filter) => ({
  ...filter,
  transform: (value: any) => {
    if (Array.isArray(value)) return new InFilter({ field: filter.field, value, objectId: true });
    return new TermFilter({ field: filter.field, value, objectId: true });
  },
});

export const createTemplateFilter = (serviceType: ServiceType): Filter =>
  withObjetIdFilter({
    fetchFunc: TemplateService.search,
    filter: 'common:template',
    translate: true,
    type: FilterType.DYNAMIC_LIST,
    queryKey: TEMPLATES_LIST_KEY,
    key: 'survey',
    field: 'template',
    fetchOption: {
      filters: new TermFilter({ field: 'serviceType', value: serviceType }),
    },
  });

export const analitycsClientFilter = withObjetIdFilter(clientFilter);

export const analitycsEstablishmentFilter = withObjetIdFilter(establishmentFilter);
